import React from 'react';
import PropTypes from 'prop-types';
import { getDateTime, getEnv } from 'utils';
import { UiProgress, UiIcon, UiButton, UiLabel } from 'ui-components';
import { useTranslation } from 'react-i18next';
import { StyledNotif } from './Notif.styles';

const Notif = (props) => {
  const { t } = useTranslation();
  const {
    url,
    status,
    title,
    time: dateTime,
    percent,
    isRead,
    name,
    type,
    dl_url,
  } = props;
  const { date, time } = getDateTime(dateTime);

  const getDownloadUrl = () => {
    if (dl_url) return dl_url;
    return `${getEnv('REACT_APP_BASE_API')}/search${url}`;
  };

  const parseDigitPercent = (percent) => {
    const digitNumber = Number(percent).toLocaleString('en', {
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return digitNumber;
  };

  const icon =
    type === 'search_excel' ? 'ri-file-excel-line' : 'ri-file-word-line';

  return (
    <StyledNotif>
      <div className='notif'>
        <div className='flex gap-10'>
          {/* نقطه اول خط */}
          {!isRead && <span className='bullet'></span>}

          {/* آیکن excel */}
          <UiIcon icon={icon} color='#4C6FFF' hover='#4C6FFF' />

          {/* متن پیشفرض */}
          <span className='file-is-ready'>
            {t('notifications:prepareOutput', { name })}
          </span>

          {/* تاریخ دریافت */}
          <bdi className='date-time'>
            <span className='mr-5'>{date}</span>
            {time}
          </bdi>
        </div>

        {/* عنوان بولتن */}
        <h3 className='file-name mb-5'>
          {`${name} `}
          <bdi>{title}</bdi>
        </h3>

        {/* پروگرس بار */}
        <div className='flex mb-10'>
          <UiLabel className='ml-10 text-primary' color='#4C6FFF' size={12}>
            {parseDigitPercent(percent)}%
          </UiLabel>
          <div className='flex-1'>
            <UiProgress value={percent} />
          </div>
        </div>

        {/* دکمه دانلود */}
        <UiButton
          variant='outlined'
          disabled={status !== 4}
          fullWidth
          target='_blank'
          href={status === 4 && getDownloadUrl()}
        >
          <div className='flex between'>
            <UiIcon
              icon={icon}
              color='#199DA3'
              hover='#199DA3'
              className='ml-10'
            />
            <span>{t('notifications:downloadFile', { name })}</span>
          </div>
        </UiButton>
      </div>
    </StyledNotif>
  );
};

Notif.propTypes = {
  url: PropTypes.string,
  percent: PropTypes.number,
  status: PropTypes.number,
  title: PropTypes.string,
  time: PropTypes.string,
  isRead: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.string,
  dl_url: PropTypes.string,
};

export default Notif;
